import React from 'react';

import { Logout } from '@app/components/Logout/Logout';

interface ErrorMessageProps {
  /** The error message to display to the user */
  message: string;
  /** The user's login ID for support purposes */
  loginId: string | undefined;
}

/**
 * ErrorMessage component displays authentication and loading errors.
 *
 * Shows the error message, user ID for support purposes, and provides
 * a logout option for the user to try again.
 */
export const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, loginId }) => (
  <div className="text-container">
    <div className="connectingText error">
      {`${message}\n`}
    </div>
    <div>
      {`User id: ${loginId}\n`}
    </div>
    <div>
      Please contact support@himarley.com with a screenshot of this page
    </div>
    <Logout />
  </div>
);
